import { useMemo } from "react";
import { GetRegistrationModel } from "@factory/model/query-model-registration";
import { calendarUtils } from "@shared/utility/calendar-utils/calendar-utils";

export function useCalendarEvents(registrationData: GetRegistrationModel[]) {
  const hasValidDateTime = (registration: GetRegistrationModel): boolean => {
    return !!(registration.date && registration.time);
  };

  const preAssignedEvents = useMemo(
    () => registrationData.filter(hasValidDateTime),
    [registrationData]
  );

  const unassignedEvents = useMemo(
    () =>
      registrationData.filter(
        (registration) => !hasValidDateTime(registration)
      ),
    [registrationData]
  );

  const calendarEvents = useMemo(
    () =>
      preAssignedEvents.map((event) => ({
        title: calendarUtils.formatClientName(event),
        start: calendarUtils.combineDateTime(event.date!, event.time!),
        end: calendarUtils.addHourToTime(event.date!, event.time!),
        extendedProps: event,
      })),
    [preAssignedEvents]
  );

  return {
    preAssignedEvents,
    unassignedEvents,
    calendarEvents,
    hasValidDateTime,
  };
}
